(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('blocked-phone.receiveNew', {
            parent: 'blocked-phone',
            url: '/receiveNew',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$state', 'AlertService', 'BlockedPhoneExtReceive', function($state, AlertService, BlockedPhoneExtReceive) {
                BlockedPhoneExtReceive.get(onSaveSuccess);
                function onSaveSuccess(result) {
                    if(result.count > 0) {
                        AlertService.warning("telestatApp.blockedPhone.newBlockedPhonesLoaded", result);
                    } else {
                        AlertService.warning("telestatApp.blockedPhone.noNewBlockedPhones");
                    }
                    $state.go('blocked-phone', null, { reload: 'blocked-phone' });
                }
            }]
        })
        .state('blocked-phone.uploadAll', {
            parent: 'blocked-phone',
            url: '/uploadAll',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$state', 'AlertService', 'BlockedPhoneExtUpload', function($state, AlertService, BlockedPhoneExtUpload) {
                BlockedPhoneExtUpload.get(onSaveSuccess);
                function onSaveSuccess(result) {
                    if(result.count > 0) {
                        AlertService.warning("telestatApp.blockedPhone.newBlockedPhonesUploaded", result);
                    } else {
                        AlertService.warning("telestatApp.blockedPhone.noNewBlockedPhonesUploaded");
                    }
                    $state.go('blocked-phone', null, { reload: 'blocked-phone' });
                }
            }]
        });
    }

})();
